import i18n from "@/i18n";
import { getNavTitleForPathname, pathMatchesItem } from "@/config/sidebar-nav";

/**
 * Routes that have no sidebar entry, mapped to a key in the `nav` namespace.
 * Everything in the sidebar config titles itself by its nav label, so this
 * map only carries the pages the nav never lists (auth, personal profile,
 * mobile More, URL-only settings) and is checked before the nav so
 * `/settings/ai` does not inherit the Settings index title.
 */
const NON_NAV_TITLE_KEYS: Record<string, string> = {
  "/more": "more",
  "/profile": "titles.profile",
  "/settings/ai": "titles.intelligence",
  "/sign-in": "titles.signIn",
  "/impersonate": "titles.signIn",
  "/onboarding": "titles.onboarding",
  "/forgot-password": "titles.forgotPassword",
  "/create-account": "titles.createAccount",
  "/invite/accept": "titles.acceptInvite",
  "/join": "titles.join",
  "/inactive": "titles.inactiveAccount",
  "/debug": "titles.debug",
};

function nonNavTitleKey(pathname: string): string | undefined {
  if (NON_NAV_TITLE_KEYS[pathname]) return NON_NAV_TITLE_KEYS[pathname];
  const candidates = Object.keys(NON_NAV_TITLE_KEYS)
    .filter((path) => pathMatchesItem(pathname, path))
    .sort((a, b) => b.length - a.length);
  return candidates[0] ? NON_NAV_TITLE_KEYS[candidates[0]] : undefined;
}

/** The `document.title` for a pathname: the nav label, or a non-nav title, or the app name. */
export function getPageTitle(pathname: string): string {
  const key =
    NON_NAV_TITLE_KEYS[pathname] ??
    getNavTitleForPathname(pathname) ??
    nonNavTitleKey(pathname);
  return key ? i18n.t(key, { ns: "nav" }) : "Graftus";
}
